import { useState, FormEvent } from 'react';

export default function Contacto() {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    empresa: '',
    mensaje: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d62lu425dngp5anjaj00', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nombre: '',
          email: '',
          telefono: '',
          empresa: '',
          mensaje: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contacto" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-8 lg:px-16">
        <div className="grid lg:grid-cols-2 gap-16">
          <div>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Contáctanos
            </h2>
            <p className="text-lg text-gray-600 mb-12 leading-relaxed">
              Estamos aquí para apoyarte en el crecimiento de tu negocio. Completa el formulario y nuestro equipo se pondrá en contacto contigo a la brevedad.
            </p>

            <div className="space-y-8">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-[#0066CC]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-2xl text-[#0066CC]"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1">Ubicación</h4>
                  <p className="text-gray-600">
                    San Pedro Sula, Cortés<br />
                    Valle de Sula, Honduras
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-[#2E7D32]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-2xl text-[#2E7D32]"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1">Teléfono</h4>
                  <p className="text-gray-600">+504 3363-5982</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-[#5D4037]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-2xl text-[#5D4037]"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1">Email</h4>
                  <p className="text-gray-600">info@cdemipyme.hn</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-[#0066CC]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-2xl text-[#0066CC]"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1">Horario de Atención</h4>
                  <p className="text-gray-600">
                    Lunes a Viernes: 8:00 AM - 4:00 PM
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-12">
              <h4 className="font-bold text-gray-900 mb-4">Nuestra Ubicación</h4>
              <div className="w-full h-48 rounded-lg overflow-hidden border border-gray-200">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3847.0!2d-88.0259!3d15.5049!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8f665c0a2a2a2a2a%3A0x0!2zMTXCsDMwJzE3LjYiTiA4OMKwMDEnMzMuMiJX!5e0!3m2!1ses!2shn!4v1704067200000!5m2!1ses!2shn"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Ubicación CDE MIPYME Valle de Sula"
                ></iframe>
              </div>
              <a
                href="https://maps.app.goo.gl/TT19h6i81FA7vE3M8"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center text-sm text-[#0066CC] hover:underline mt-3 cursor-pointer"
              >
                <i className="ri-external-link-line mr-1"></i>
                Ver en Google Maps
              </a>
            </div>

            <div className="mt-12">
              <h4 className="font-bold text-gray-900 mb-4">Síguenos en Redes Sociales</h4>
              <div className="flex space-x-4">
                <a
                  href="https://www.facebook.com/share/14WjtBXcsxX/?mibextid=wwXIfr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center hover:bg-[#0066CC] hover:text-white transition-colors"
                >
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a
                  href="https://www.instagram.com/cdemipymervs?igsh=MXQ1eWlucnhkaHNocg%3D%3D&utm_source=qr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center hover:bg-[#0066CC] hover:text-white transition-colors"
                >
                  <i className="ri-instagram-line text-xl"></i>
                </a>
                <a
                  href="https://youtube.com/@cdemipymervs?si=zkjL8PZGuYKflsWa"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center hover:bg-[#0066CC] hover:text-white transition-colors"
                >
                  <i className="ri-youtube-line text-xl"></i>
                </a>
                <a
                  href="https://whatsapp.com/channel/0029Vb6BHBp4IBh5TykghK06"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center hover:bg-[#0066CC] hover:text-white transition-colors"
                >
                  <i className="ri-whatsapp-line text-xl"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="bg-[#F8F9FA] rounded-2xl p-8 lg:p-10">
            <form id="contacto-form" onSubmit={handleSubmit} data-readdy-form>
              <div className="space-y-6">
                <div>
                  <label htmlFor="nombre" className="block text-sm font-semibold text-gray-900 mb-2">
                    Nombre Completo *
                  </label>
                  <input
                    type="text"
                    id="nombre"
                    name="nombre"
                    required
                    value={formData.nombre}
                    onChange={(e) => setFormData({ ...formData, nombre: e.target.value })}
                    className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#0066CC] text-sm"
                    placeholder="Tu nombre"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-semibold text-gray-900 mb-2">
                    Correo Electrónico *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#0066CC] text-sm"
                    placeholder="tu@email.com"
                  />
                </div>

                <div>
                  <label htmlFor="telefono" className="block text-sm font-semibold text-gray-900 mb-2">
                    Teléfono *
                  </label>
                  <input
                    type="tel"
                    id="telefono"
                    name="telefono"
                    required
                    value={formData.telefono}
                    onChange={(e) => setFormData({ ...formData, telefono: e.target.value })}
                    className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#0066CC] text-sm"
                    placeholder="+504 0000-0000"
                  />
                </div>

                <div>
                  <label htmlFor="empresa" className="block text-sm font-semibold text-gray-900 mb-2">
                    Nombre de tu Empresa
                  </label>
                  <input
                    type="text"
                    id="empresa"
                    name="empresa"
                    value={formData.empresa}
                    onChange={(e) => setFormData({ ...formData, empresa: e.target.value })}
                    className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#0066CC] text-sm"
                    placeholder="Nombre de tu negocio"
                  />
                </div>

                <div>
                  <label htmlFor="mensaje" className="block text-sm font-semibold text-gray-900 mb-2">
                    Mensaje *
                  </label>
                  <textarea
                    id="mensaje"
                    name="mensaje"
                    required
                    rows={4}
                    maxLength={500}
                    value={formData.mensaje}
                    onChange={(e) => setFormData({ ...formData, mensaje: e.target.value })}
                    className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#0066CC] resize-none text-sm"
                    placeholder="Cuéntanos cómo podemos ayudarte..."
                  ></textarea>
                  <p className="text-xs text-gray-500 mt-1">{formData.mensaje.length}/500 caracteres</p>
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-[#0066CC] text-white py-4 rounded-lg font-semibold hover:bg-[#0052A3] transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
                >
                  {isSubmitting ? 'Enviando...' : 'Enviar Mensaje'}
                </button>

                {submitStatus === 'success' && (
                  <div className="bg-green-50 border border-green-200 text-green-800 px-4 py-3 rounded-lg text-sm">
                    ¡Mensaje enviado exitosamente! Nos pondremos en contacto contigo pronto.
                  </div>
                )}

                {submitStatus === 'error' && (
                  <div className="bg-red-50 border border-red-200 text-red-800 px-4 py-3 rounded-lg text-sm">
                    Hubo un error al enviar el mensaje. Por favor, intenta nuevamente.
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
